<template>
  <div class="p-3 flex flex-col gap-y-2">
    <p>{{ $t('mohreotpMsg') }}</p>
    <Form v-slot="{ values }">
      <Field :rules="requiredRule" name="otp" v-slot="{ field, errors: errs }">
        <TextInput
          :field="field"
          :errors="errs"
          :label="$t('emailOtpCode')"
          input-class="px-3 py-1.5"
          label-class="w-full"
          direction="flex-col"
        >
          <template #bottomAppendage>
            <span v-if="otpConfig.isSent && otpConfig.timerHalfLife > 0">
              {{ $t('otpParagraph2', { countdown: otpConfig.timerHalfLife }) }}
            </span>
            <button
              v-else
              class="text-start text-primary"
              @click.prevent="sendOtp(otpConfig.email)"
            >
              {{ $t('resend') }}
            </button>
          </template>
        </TextInput>
      </Field>
      <div class="pt-2 w-full flex justify-end">
        <button
          class="px-4 py-1 text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
          @click.prevent="verifyOtp(values)"
        >
          {{ $t('Save') }}
        </button>
      </div>
    </Form>
  </div>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import axiosInstance from '@/services'
import { useInterval } from '@vueuse/core'
import { Field, Form } from 'vee-validate'
import { onMounted, reactive, watch } from 'vue'

const emit = defineEmits(['onVerified'])

const TIME_LIMIT = 60

const props = defineProps({
  user: {
    type: Object,
    requried: true
  },
  sendFunc: Object,
  verifyFunc: Object
})

const otpConfig = reactive({
  isSent: false,
  showOtpTimer: false,
  timerHalfLife: TIME_LIMIT,
  showVerificationModal: false,
  intervalConfig: null,
  watcher: null,
  email: null
})

onMounted(async () => {
  await sendOtp()
})

async function sendOtp() {
  const body = { ...props.user }
  await axiosInstance.post('/api/establishment/mohreWorkPackage/request/sendOTP', body)

  if (otpConfig.intervalConfig) {
    otpConfig.watcher?.()
    otpConfig.isSent = false
    otpConfig.showOtpTimer = false
    otpConfig.timerHalfLife = TIME_LIMIT
    otpConfig.showVerificationModal = false
    otpConfig.intervalConfig = null
    otpConfig.watcher = null
    otpConfig.email = null
  }

  activateTimer()
}

function activateTimer() {
  otpConfig.isSent = true
  otpConfig.intervalConfig = useInterval(1000, { controls: true, immediate: true })

  otpConfig.watcher = watch(
    () => otpConfig.intervalConfig?.counter,
    () => {
      if (otpConfig.timerHalfLife === 0) {
        otpConfig.intervalConfig.reset()
        return
      }
      otpConfig.timerHalfLife -= 1
    }
  )
}

async function verifyOtp(form) {
  const { otp } = form
  const path = `/api/establishment/mohreWorkPackage/request/otp/${otp}/validate`

  await axiosInstance.post(path, props.user)

  emit('onVerified')
}
</script>

<style lang="scss" scoped></style>
